module.exports = __webpack_public_path__ + "img/cn_3.6a29aaaa.jpg";